import { computed, ref } from 'vue';

export const enum ResponseErrorStatusCode {
  INTERNAL_SERVER_ERROR = '500',
  UNAUTHORIZED = '401',
  PAYMENT_REQUIRED = '402',
  FORBIDDEN = '403',
  NOT_FOUND = '404',
}

export const ErrorType = {
  BEFORE_CONTENT_LOAD: 'beforeContentLoad',
  ON_CONTENT_LOAD: 'onContentLoad',
} as const;

type ErrorTypeUnion = (typeof ErrorType)[keyof typeof ErrorType];

interface ErrorEntry {
  id: ResponseErrorStatusCode;
  type: ErrorTypeUnion;
}

export class ErrorWithStatus extends Error {
  status: number;

  constructor(...args) {
    super(...args);
  }
}

const error = ref<ErrorEntry>(null);
const errorID = computed<ResponseErrorStatusCode>(() => error.value?.id || null);
const canClearError = ref<boolean>(false);

const showErrorWith = (id: ResponseErrorStatusCode, type: ErrorTypeUnion = ErrorType.ON_CONTENT_LOAD) => {
  error.value = {
    id,
    type,
  };
};

const setCanCleanError = (value: boolean) => {
  canClearError.value = value;
};

const hideError = () => {
  error.value = null;
};

export default () => ({
  canClearError,
  error,
  errorID,
  hideError,
  setCanCleanError,
  showErrorWith,
});

export const ResponseError = (status: number, message?: string) => {
  const error = new ErrorWithStatus(message || status.toString());
  error.status = status;

  return error;
};
